import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/shared/useAddToCartState.ts
import { useEffect, useRef, useState } from "react";
var SETTLED_MS = 2e3;
function addToCartAriaLabel(t, state, title) {
  if (state === "added") return t("product.addedAria", { title });
  if (state === "error") return t("product.failedAria", { title });
  return t("product.addToCartAria", { title });
}
function useAddToCartState(onAddToCart) {
  const [states, setStates] = useState({});
  const [outcome, setOutcome] = useState(null);
  const timersRef = useRef(/* @__PURE__ */ new Set());
  useEffect(() => {
    const timers = timersRef.current;
    return () => timers.forEach(clearTimeout);
  }, []);
  const cartStateOf = (productId) => states[productId] ?? "idle";
  const settle = (product, state) => {
    const settled = { product, state };
    setStates((prev) => ({ ...prev, [product.id]: state }));
    setOutcome(settled);
    const timer = setTimeout(() => {
      timersRef.current.delete(timer);
      setStates((prev) => ({ ...prev, [product.id]: "idle" }));
      setOutcome((prev) => prev === settled ? null : prev);
    }, SETTLED_MS);
    timersRef.current.add(timer);
  };
  const addToCart = async (product) => {
    if (!onAddToCart) return;
    const state = cartStateOf(product.id);
    if (state === "loading" || state === "added") return;
    setStates((prev) => ({ ...prev, [product.id]: "loading" }));
    try {
      await onAddToCart(product);
      settle(product, "added");
    } catch {
      settle(product, "error");
    }
  };
  return { cartStateOf, addToCart, outcome };
}
export {
  addToCartAriaLabel,
  useAddToCartState
};
//# sourceMappingURL=useAddToCartState.mjs.map